import { render, staticRenderFns } from "./deporder.vue?vue&type=template&id=86d82fea&scoped=true&"
import script from "./deporder.vue?vue&type=script&lang=js&"
export * from "./deporder.vue?vue&type=script&lang=js&"
import style0 from "./deporder.vue?vue&type=style&index=0&id=86d82fea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d82fea",
  null
  
)

export default component.exports